export const asField = {
  data: `<svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.99333 12.6702L3.08 8.85022L2 9.69022L8 14.3569L14 9.69022L12.9133 8.84355L7.99333 12.6702ZM8 10.9769L12.9067 7.15689L14 6.31022L8 1.64355L2 6.31022L3.08667 7.15689L8 10.9769ZM8 3.33022L11.8267 6.31022L8 9.29022L4.17333 6.31022L8 3.33022Z"/>
  </svg>
  `,
  name: 'field',
};
